import React, { useContext } from "react";
import Accordion from "../../components/common/accordian";
import ApplicationContext from "../../context/index";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box, Grid, Hidden, Typography } from "@material-ui/core";
import { useStyles } from "../proposal/indexFormStyles";
import { NOT_AVAILABLE_TEXT } from "../../constants";
import moment from "moment";

function ProfileSection(props) {
  const {
    state: { profileDetails = null },
  } = useContext(ApplicationContext);
  const {
    classes: { bgGray, container, gutterTop, main, label, userAccount, wordBreak },
    disabledAccordion = false,
  } = props;

  const renderField = (labelName, labelValue) => {
    return (
      <Box className={gutterTop} justifyContent={"left"} textAlign="left">
        <Typography variant={"body2"} gutterBottom className={label}>
          {labelName}
        </Typography>
        <Typography variant={"body2"} className={wordBreak}>
          {labelValue}
        </Typography>
      </Box>
    );
  };

  return (
    <Box className={main} m={5}>
      <Box container={"true"} justifyContent="center" className={container}>
        <Accordion
          title={"Service Centre Details"}
          disabled={disabledAccordion}
        >
          <Box direction="column" style={{ width: "100%" }} m={2}>
            <Grid container spacing={2}>
              <Grid container item md={5} direction="column">
                {renderField("Name", profileDetails?.name)}
                {renderField("Mobile", profileDetails?.mobile)}
              </Grid>

              <Hidden smDown>
                <Grid container item md={2} direction="column"></Grid>
              </Hidden>

              <Grid container item md={5} direction="column">
                {renderField("Email", profileDetails?.email)}

                {renderField(
                  "Address",
                  profileDetails?.address
                    ? `${profileDetails?.address?.address_line_1}, ${profileDetails?.city}, ${profileDetails?.state}, ${profileDetails?.pincode}`
                    : NOT_AVAILABLE_TEXT
                )}
              </Grid>
            </Grid>
          </Box>
        </Accordion>

        <Accordion title={"User Account Details"} disabled={disabledAccordion}>
          <Box direction="column" style={{ width: "100%" }}>
            {profileDetails?.user.map((item, index) => {
              return (
                <Box
                  direction="column"
                  className={`${userAccount} ${index % 2 === 0 && bgGray}`}
                  m={1}
                  p={2}
                >
                  <Grid container spacing={2}>
                    <Grid container item md={2} direction="column">
                      {renderField("Mobile", item.mobile)}
                    </Grid>
                    <Grid container item md={3} direction="column">
                      {renderField("Email", item?.email)}
                    </Grid>
                    <Grid container item md={2} direction="column">
                      {renderField("Password", "*******")}
                    </Grid>
                    {/* <Grid container item md={2} direction="column">
                      {renderField(
                        "Type",
                        item?.type === "P" ? "Primary" : "Secondary"
                      )}
                    </Grid> */}
                    <Grid container item md={2} direction="column">
                      {renderField("Creation Date", moment(item?.created_at).format("DD-MM-YYYY"))}
                    </Grid>
                    <Grid container item md={2} direction="column">
                      {renderField("Active", item?.is_active ? "Yes" : "No")}
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
          </Box>
        </Accordion>

        <Accordion
          title={"Bank Details"}
          defaultExpanded={true}
          disabled={false}
        >
          <Box direction="column" style={{ width: "100%" }} m={2}>
            <Grid container spacing={2}>
              <Grid container item md={5} direction="column">
                {renderField(
                  "Account Holder Name",
                  profileDetails?.neft?.beneficiary_name
                )}

                {renderField(
                  "Account Number",
                  profileDetails?.neft?.account_number
                )}

                {renderField("IFSC Code", profileDetails?.neft?.ifsc_code)}
              </Grid>

              <Hidden smDown>
                <Grid container item md={2} direction="column"></Grid>
              </Hidden>

              <Grid container item md={5} direction="column">
                {renderField("GST", profileDetails?.gst)}

                {renderField("PAN", profileDetails?.pan)}
              </Grid>
            </Grid>
          </Box>
        </Accordion>
      </Box>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(ProfileSection);
